"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const tooltip_1 = require("./components/ui/tooltip");
const AuthProvider_1 = require("./providers/AuthProvider");
const LocaleProvider_1 = require("./providers/LocaleProvider");
const ToastProvider_1 = require("./providers/ToastProvider");
const router_1 = require("./router");
const App = () => ((0, jsx_runtime_1.jsx)(LocaleProvider_1.LocaleProvider, { children: (0, jsx_runtime_1.jsx)(AuthProvider_1.AuthProvider, { children: (0, jsx_runtime_1.jsx)(tooltip_1.TooltipProvider, { children: (0, jsx_runtime_1.jsx)(ToastProvider_1.ToastProvider, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.RouterProvider, { router: router_1.router }) }) }) }) }));
exports.App = App;
